import React, { FC, useState, useContext } from 'react';
import { WorkPackagesList } from './workpackage';
import { ForemanSelector } from './foreman-selector';
import { WeekSelector } from './week-selector';
import {
  PlanningListContainerStyled,
  PlanningListCollapsedStyled,
  ListContainerStyled,
  ExpandCollapseBoxStyled,
  ExpandCollapseBorderBoxStyled,
} from './styled';
import { PlanningListViewProps } from './types';
import { Icon, IconSize, useMediaQuery, belowBreakpoint, Theme } from '@bechtel/gds';
import { ThemeContext } from 'styled-components';
import { PlanningTab } from '../types';

export const PlanningListView: FC<PlanningListViewProps> = ({
  expiredMilestoneStats,
  isListCollapsed,
  onToggleCollapse,
  selectedTab,
  onSelectWeek,
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { breakpoints } = useContext<Theme>(ThemeContext);
  const isWideScreen = useMediaQuery(belowBreakpoint(breakpoints.widescreen));
  return (
    <ListContainerStyled isListCollapsed={isListCollapsed}>
      <PlanningListContainerStyled isDrawerOpen={isDrawerOpen} isListCollapsed={isListCollapsed}>
        <ForemanSelector expiredMilestoneStats={expiredMilestoneStats} selectedTab={selectedTab} />
        {(selectedTab == PlanningTab.PLAN /*|| selectedTab == PlanningTab.TIMELINE*/) && (
          <WorkPackagesList setDrawerStatus={setIsDrawerOpen} />
        )}
        {selectedTab == PlanningTab.PROGRESS && <WeekSelector onSelectWeek={onSelectWeek} />}
      </PlanningListContainerStyled>
      <PlanningListCollapsedStyled isListCollapsed={isListCollapsed}></PlanningListCollapsedStyled>

      {isWideScreen && !isDrawerOpen && (
        <ExpandCollapseBorderBoxStyled isListCollapsed={isListCollapsed}>
          <ExpandCollapseBoxStyled onClick={onToggleCollapse}>
            <Icon
              icon={isListCollapsed ? 'chevron-right' : 'chevron-left'}
              size={IconSize.MEDIUM}
              fillColor="blue.800"
            />
          </ExpandCollapseBoxStyled>
        </ExpandCollapseBorderBoxStyled>
      )}
    </ListContainerStyled>
  );
};
